export default __webpack_public_path__ + "static/media/petal_EmotionalHealth.bf985abb.svg";